export default function List({data = [], input = "" ,onSelectItem}){

    //create a new array by filtering the origional array

    const filteredData = data.filter((el)=>{

        //if no input then return the orgional

        if (input === '') {
        return false; // return nothing if input is empty
        }

        //return the item which contains the user input
        return(
          el.english.toLowerCase().includes(input.toLowerCase()) ||
          el.korean.includes(input) ||
          el.romanization.toLowerCase().includes(input.toLowerCase()) 
      
        )
    })

  return (
    <div className="results-container">
      {filteredData.map((item) => (
        <div 
          key={item.id} 
          className="result-item"
          onClick={() => onSelectItem(item)}
          >        
          <strong>{item.english}</strong> — {item.korean}
        </div>
      ))}
    </div>
  );
}